<template>
  <div class="bill">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="商城发票索取" name="askBill">
        <AskBill ref="askBill" />
      </el-tab-pane>
      <el-tab-pane label="开票历史" name="publishedBill">
        <PublishedBill ref="publishedBill" />
      </el-tab-pane>
      <el-tab-pane label="设置发票预留信息" name="reserveBill">
        <ReserveBill ref="reserveBill" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import AskBill from "./components/AskBill";
import PublishedBill from "./components/PublishedBill";
import ReserveBill from "./components/ReserveBill";
export default {
  components: {
    AskBill,
    PublishedBill,
    ReserveBill,
  },
  data() {
    return {
      activeName: "askBill",
    };
  },
  methods: {
    handleClick({ name }) {
      const { getTableData } = this.$refs[name];
      if (getTableData && typeof getTableData === "function") {
        this.$refs[name].getTableData();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.bill {
  padding: 0 10px 10px 10px;
}
</style>
